import axios from "axios";
import { API_URL } from "./apiUrl";

// export const API_URL = 'https://montenegromice.com/mice-api';

export const fetchAmenitiesLists = () => {
  return axios
    .get(`${API_URL}/amenities-list`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(error.message);
    });
};

export const deleteAmenitiesList = (amenitiesListId) => {
  return axios
    .delete(`${API_URL}/amenities-list/${amenitiesListId}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(`Greška pri brisanju dokumenta: ${error.message}`);
    });
};

export const getAmenitiesList = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/amenities-list/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(`Greška pri dobavljanju dokumenta: ${error.message}`);
  }
};

export const editAmenitiesList = async (id, amenitiesListData) => {
  try {
    const response = await axios.put(
      `${API_URL}/amenities-list/${id}`,
      amenitiesListData
    );
    return response.data;
  } catch (error) {
    throw new Error(`Greška pri editovanju dokumenta: ${error.message}`);
  }
};

export const addAmenitiesList = (amenitiesListData) => {
  return axios
    .post(`${API_URL}/amenities-list`, amenitiesListData)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(`Greška pri dodavanju dokumenta: ${error.message}`);
    });
};
